module.exports = __webpack_public_path__ + "img/tanayu.5c3a53d0.jpg";